import styled from 'styled-components';

export const CardBody = styled.div`
  display: flex;
  align-items: start;
  cursor: pointer;
  gap: 16px;
  & .title {
    width: 90%;
    font-size: 22px;
    font-weight: 600;
  }
`;
